const poundsFormatter = Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP'
});

export { poundsFormatter };
